/**
 * Statsig client key for the loan-officer (LOS) app.
 *
 * Client keys are public by design: they ship inside the browser bundle.
 * The reason this lives in its own module is project routing, not secrecy.
 * Every Statsig entry point in this app MUST import this constant so that
 * pointing the LOS app at a different Statsig project stays a one-line change.
 *
 * Known entry points:
 *   - statsig/statsigWrapper.js        (the app-wide provider)
 *   - MortgageGPT/components/GetLenders/Banner.tsx
 *       (renders inside notification.info, i.e. outside the provider tree,
 *        so it has to init its own client)
 */
export const STATSIG_CLIENT_KEY =
    'client-uqUh75VjWL0jwYGwv7R6qu09epEniRaL9EhRUEbwMTU'

export default STATSIG_CLIENT_KEY
